var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8268 3.63867C25.9847 2.94645 26.8511 1.85648 27.2642 0.572256C26.1762 1.21783 24.9858 1.6726 23.7444 1.91688C22.0234 0.096312 19.2966 -0.346732 17.0877 0.835311C14.8788 2.01735 13.7346 4.53185 14.2946 6.97376C9.83783 6.75 5.68558 4.64477 2.87108 1.18192C1.40225 3.71542 2.15286 6.9541 4.58642 8.58317C3.70642 8.55488 2.84593 8.31662 2.07671 7.88826C2.07671 7.91151 2.07671 7.93476 2.07671 7.95801C2.07722 10.5971 3.93719 12.8703 6.52392 13.3933C5.70767 13.6154 4.85148 13.6481 4.02067 13.4889C4.74813 15.7458 6.82817 17.292 9.19896 17.3381C7.23541 18.8792 4.81049 19.715 2.31438 19.7109C1.87194 19.7115 1.42986 19.6861 0.990417 19.6347C3.52517 21.2635 6.47531 22.1281 9.48829 22.125C13.6801 22.1538 17.7085 20.5013 20.6725 17.537C23.6365 14.5728 25.2887 10.5442 25.2595 6.35246C25.2595 6.11221 25.2539 5.87326 25.2427 5.63559C26.3283 4.85103 27.2653 3.87912 28.0095 2.76551C26.9981 3.2138 25.9254 3.50811 24.8268 3.63867Z",
    fill: "#3E4756"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialTwitter);
export default __webpack_public_path__ + "static/media/IconSocialTwitter.1101adac.svg";
export { ForwardRef as ReactComponent };